import React from 'react';
import { bezpiecznyObrazPodpisu, jestPodpisObrazkowy } from '../utils/podpis';

const ROZMIARY = {
  sm: 'text-xl',
  md: 'text-2xl sm:text-3xl',
  lg: 'text-3xl sm:text-4xl'
};

/**
 * Wyświetla podpis: pisany (czcionka odręczna) albo obrazkowy (starsze wnioski).
 * `className` trafia na element podpisu (obraz lub tekst).
 */
const Podpis = ({ value, alt = 'Podpis', size = 'md', className = '' }) => {
  if (!value) return null;
  if (jestPodpisObrazkowy(value)) {
    const src = bezpiecznyObrazPodpisu(value);
    if (!src) return null;
    return <img src={src} alt={alt} className={className} />;
  }
  return (
    <span
      className={`font-podpis inline-block leading-tight text-gray-900 break-words ${ROZMIARY[size] || ROZMIARY.md} ${className}`}
      aria-label={alt}
    >
      {value}
    </span>
  );
};

export default Podpis;
